import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeftIcon, ChevronRightIcon } from '../AriesIcons';

/**
 * AriesDateNavigator - presentational date/period stepper: a red left chevron,
 * a centered period label, and a red right chevron. Fully controlled; the
 * consumer owns the current period and supplies the formatted label plus the
 * prev/next handlers (this component applies no date logic).
 */
const AriesDateNavigator = ({ label, onPrev, onNext, className }) => (
  <div className={`aries-date-nav ${className}`}>
    <button
      type="button"
      className="aries-date-nav-btn"
      aria-label="Previous"
      onClick={onPrev}
    >
      <ChevronLeftIcon size={20} />
    </button>
    <span className="aries-date-nav-label">{label}</span>
    <button
      type="button"
      className="aries-date-nav-btn"
      aria-label="Next"
      onClick={onNext}
    >
      <ChevronRightIcon size={20} />
    </button>
  </div>
);

AriesDateNavigator.propTypes = {
  label: PropTypes.node,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  className: PropTypes.string,
};

AriesDateNavigator.defaultProps = {
  label: '',
  onPrev: () => {},
  onNext: () => {},
  className: '',
};

export default AriesDateNavigator;
